import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

// Columns that hold a yes/no flag and are drawn as an icon instead of text.
const BOOLEAN_ICON_FIELDS = ['hasGarage'];

export const isBooleanIconField = field => BOOLEAN_ICON_FIELDS.includes(field);

// Green check when the flag is set, an empty grey circle when it is not.
const BooleanCell = ({value, title}) => {
  const label = title ? `${title}: ${value ? 'yes' : 'no'}` : value ? 'yes' : 'no';
  return value ? (
    <CheckCircleIcon color="success" fontSize="small" titleAccess={label} />
  ) : (
    <RadioButtonUncheckedIcon color="disabled" fontSize="small" titleAccess={label} />
  );
};

export default BooleanCell;
